// https://medium.com/ascentic-technology/how-to-connect-azure-ad-b2c-with-react-js-b90b63e6b9b7
// Caution: DO NOT change url params unless you change the whitelist in azure as well, otherwise you end up with funny undebuggable issues
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';
import { b2cPolicies } from './policies';
import { AZURE_B2C_CONFIG } from 'projectConfig';

const applicationId = APPLICATION_ID;
// Dynamic build redirect uri and logout redirect uri
const currentOrigin = window.location.origin;
const reactRedirectUri = `${currentOrigin}${AZURE_B2C_CONFIG.redirectPath}`;
const postLogoutRedirectUri = `${currentOrigin}${AZURE_B2C_CONFIG.logoutRedirectPath}`;

// skip email/phone verification for development
// disasble signup for kosmos
// export const getSigninPolicy = (): string => {
//   const isKosmos = PROJECT === 'kosmos';
//   if (isKosmos) {
//     return b2cPolicies.authorities.customKosmosSignin.authority;
//   } else {
//     const authority =
//       isDevelopment || AZURE_B2C_CONFIG.simpleSignup == 'true'
//         ? b2cPolicies.authorities.customSimpleSiSu.authority
//         : b2cPolicies.authorities.customSiSu.authority;
//     return authority;
//   }
// };

export const getSigninPolicy = (): string => {
  return b2cPolicies.authorities.customKosmosSignin.authority;
};

export const getSigninPolicyName = (): string => {
  return b2cPolicies.names.customKosmosSignin.toLowerCase();
};

// Msal Configurations
const signInConfig = {
  auth: {
    authority: getSigninPolicy(),
    clientId: applicationId,
    redirectUri: reactRedirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    validateAuthority: false,
    navigateToLoginRequestUrl: true, // go to the url which triggered the login action
    knownAuthorities: [`${APPLICATION_NAMESPACE}.b2clogin.com`],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // only for IE
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: false,
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
  },
};

// console.log(signInConfig);

export const signInAuthProvider = new PublicClientApplication(signInConfig);

export const defaultHomePage = reactRedirectUri;
